import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

// Unread counts live on each DM and project in the sidebar; old /inbox links land on Home.
export const inboxRoutes: RouteObject[] = [
  { path: "inbox", element: <Navigate to="../home" replace /> },
];
